import React from "react";
import { _aligeText, _colorText, _sizeText } from "../../core/core";
import "./text.css";

interface TextProps {
  size?: _sizeText;
  color?: _colorText;
  aligeText?: _aligeText;
  is_copy?: boolean;
  children?: React.ReactNode;
}

export const Text: React.FC<TextProps> = ({
  size = _sizeText.s,
  color = _colorText.default,
  aligeText = _aligeText.left,
  is_copy = false,
  children,
  ...props
}) => {
  return (
    <p
      className={`text text-${color} text-${size} text-${aligeText} text-copy-${is_copy}`}
      {...props}
    >
      {children}
    </p>
  );
};
